import { useEffect, useState, useCallback } from "react";
import "../../Components/Page/Page.css";
import { useUser } from "../../Context/UserContext";
import { useNavigate } from "react-router-dom";

import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";

import Header2 from "../../Components/Header2/Header2";
import useAPI from "../../Hooks/useAPI";

import "./EspecDemo.css";
import SecHeader from "../../Components/SecHeader/SecHeader";
import Button2 from "../../Components/Button2/Button2";
import * as Slider from "@radix-ui/react-slider";
interface Engine {
  id: number;
  manufacturer: string;
  model: string;
  displacement_l: number;
  bore_mm: number;
  stroke_mm: number;
  compression_ratio: number;
  torque_lbft: number;
  power_output_hp: number;
  max_turbocharger_compression_psi: number;
  number_of_cylinders: number;
  cylinder_configuration: string;
  fuel_type: string;
  valvetrain: string;
  aspiration: string;
  fuel_system: string;
  redline_rpm: number;
  cooling_system: string;
  dry_weight_lb: number;
  ignition_type: string;
  maximum_rpm: number;
  stroke_type: string;
  maximum_power_output_hp: number;
  continuous_power_output_hp: number;
  dimensions: string;
  emissions_us_tier: string;
  emissions_eu_stage: string;
  engine_application: string;
  created_at: string;
  updated_at: string;
  category: string;
  data_quality_flag: boolean;
  bsfc_rated_g_kwh: number;
  bsfc_peak_torque_g_kwh: number;
  bsfc_source: string;
  brake_thermal_efficiency: number;
  compare_id: number;
}

export default function EspecDemo() {
  const [engines, setEngines] = useState<Engine[]>([]);
  const [elfEngines, setelfEngines] = useState<Engine[]>([]);
  const [noData, setNoData] = useState(false);
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { user } = useUser();
  const navigate = useNavigate();
  const { getEngines, getEngineFilters } = useAPI();

  const [selectedCategory, setSelectedCategory] = useState(() => {
    return localStorage.getItem("categoryFilter") || "";
  });
  const [selectedManufacturer, setSelectedManufacturer] = useState(() => {
    return localStorage.getItem("manufacturerFilter") || "";
  });
  const [selectedModel, setSelectedModel] = useState(() => {
    return localStorage.getItem("modelFilter") || "";
  });
  const [selectedEngineApplication, setSelectedEngineApplication] = useState(
    () => {
      return localStorage.getItem("engineApplicationFilter") || "";
    },
  );
  const [selectedNbrCylinders, setSelectedNbrCylinders] = useState(() => {
    return localStorage.getItem("nbrCylindersFilter") || "";
  });
  const [selectedCylinderConfig, setSelectedCylinderConfig] = useState(() => {
    return localStorage.getItem("cylinderConfigFilter") || "";
  });
  const [selectedFuelType, setSelectedFuelType] = useState(() => {
    return localStorage.getItem("fuelTypeFilter") || "";
  });

  const [selectedFuelSystem, setSelectedFuelSystem] = useState(() => {
    return localStorage.getItem("fuelSystemFilter") || "";
  });
  const [selectedCoolingSystem, setSelectedCoolingSystem] = useState(() => {
    return localStorage.getItem("coolingSystemFilter") || "";
  });
  const [selectedIgnitionType, setSelectedIgnitionType] = useState(() => {
    return localStorage.getItem("ignitionTypeFilter") || "";
  });
  const [selectedDisplacementMin, setSelectedDisplacementMin] = useState(() => {
    return localStorage.getItem("displacementMinFilter") || "";
  });
  const [selectedDisplacementMax, setSelectedDisplacementMax] = useState(() => {
    return localStorage.getItem("displacementMaxFilter") || "";
  });
  const [selectedCompressionRatioMin, setSelectedCompressionRatioMin] =
    useState(() => {
      return localStorage.getItem("compressionRatioMinFilter") || "";
    });
  const [selectedCompressionRatioMax, setSelectedCompressionRatioMax] =
    useState(() => {
      return localStorage.getItem("compressionRatioMaxFilter") || "";
    });
  const [selectedBoreMin, setSelectedBoreMin] = useState(() => {
    return localStorage.getItem("boreMinFilter") || "";
  });
  const [selectedBoreMax, setSelectedBoreMax] = useState(() => {
    return localStorage.getItem("boreMaxFilter") || "";
  });

  const [selectedStrokeMin, setSelectedStrokeMin] = useState(() => {
    return localStorage.getItem("strokeMinFilter") || "";
  });
  const [selectedStrokeMax, setSelectedStrokeMax] = useState(() => {
    return localStorage.getItem("strokeMaxFilter") || "";
  });

  const [selectedTorqueMin, setSelectedTorqueMin] = useState(() => {
    return localStorage.getItem("torqueMinFilter") || "";
  });
  const [selectedTorqueMax, setSelectedTorqueMax] = useState(() => {
    return localStorage.getItem("torqueMaxFilter") || "";
  });
  const [selectedPowerOutputMin, setSelectedPowerOutputMin] = useState(() => {
    return localStorage.getItem("powerOutputMinFilter") || "";
  });
  const [selectedPowerOutputMax, setSelectedPowerOutputMax] = useState(() => {
    return localStorage.getItem("powerOutputMaxFilter") || "";
  });

  const [range, setRange] = useState([0, 1000]);

  const [ddlFilterValues, setddlFilterValues] = useState({
    applications: [],
    categories: [],
    coolingsystems: [],
    cylinderconfigurations: [],
    fueltypes: [],
    fuelsystems: [],
    ignitiontypes: [],
    manufacturers: [],
  });

  const [sortConfig, setSortConfig] = useState<{
    key: keyof Engine | null;
    direction: "ascending" | "descending" | null;
  }>({
    key: null,
    direction: null,
  });

  //the field names in engineFilters below must match the fieldnames in the espec.engine_specs_main table.
  const fetchEngines = useCallback(async () => {
    try {
      setIsLoading(true);
      setError("");
      setSelectedPowerOutputMin(range[0].toString());
      setSelectedPowerOutputMax(range[1].toString());
      localStorage.setItem("powerOutputMinFilter", range[0].toString());
      localStorage.setItem("powerOutputMaxFilter", range[1].toString());

      const engineFilters = {
        category: selectedCategory,
        manufacturer: selectedManufacturer,
        model: selectedModel,
        engine_application: selectedEngineApplication,
        number_of_cylinders: selectedNbrCylinders,
        cylinder_configuration: selectedCylinderConfig,
        fuel_type: selectedFuelType,
        fuel_system: selectedFuelSystem,
        cooling_system: selectedCoolingSystem,
        ignition_type: selectedIgnitionType,
        displacement_l: {
          min: selectedDisplacementMin,
          max: selectedDisplacementMax,
        },
        compression_ratio: {
          min: selectedCompressionRatioMin,
          max: selectedCompressionRatioMax,
        },
        bore_mm: {
          min: selectedBoreMin,
          max: selectedBoreMax,
        },
        stroke_mm: {
          min: selectedStrokeMin,
          max: selectedStrokeMax,
        },
        torque_lbft: {
          min: selectedTorqueMin,
          max: selectedTorqueMax,
        },
        power_output_hp: {
          min: range[0].toString(),
          max: range[1].toString(),
        },
      };
      const response = await getEngines(0, JSON.stringify(engineFilters));

      if (response?.data) {
        // setEngines(response.data);
        setNoData(false);

        setEngines(
          (response.data as Engine[]).filter(
            (engine: Engine) => engine.manufacturer === "Modern",
          ),
        );
        setelfEngines(
          (response.data as Engine[]).filter(
            (engine: Engine) => engine.manufacturer === "Elf-Tech",
          ),
        );
        if (response?.data.length === 0) {
          setNoData(true);
        }
      } else {
        throw new Error("Failed to fetch engines");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, [
    getEngines,
    selectedCategory,
    selectedManufacturer,
    selectedModel,
    selectedEngineApplication,
    selectedNbrCylinders,
    selectedCylinderConfig,
    selectedFuelType,
    selectedFuelSystem,
    selectedCoolingSystem,
    selectedIgnitionType,
    selectedDisplacementMin,
    selectedDisplacementMax,
    selectedCompressionRatioMin,
    selectedCompressionRatioMax,
    selectedBoreMin,
    selectedBoreMax,
    selectedStrokeMin,
    selectedStrokeMax,
    selectedTorqueMin,
    selectedTorqueMax,
    selectedPowerOutputMin,
    selectedPowerOutputMax,
    range,
  ]);

  const fetchEngineFilters = useCallback(async () => {
    try {
      const response = await getEngineFilters();
      const filters = response.data[0].data;
      setddlFilterValues(filters);
    } catch (error) {
      setError("Failed to fetch engine filters");
    }
  }, []);

  useEffect(() => {
    // Check if user is logged in
    if (!user) {
      navigate("/user-login");
      return;
    }

    // if (!ddlFilterValues.) {
    fetchEngineFilters();
    // }

    fetchEngines();
  }, [user, navigate, fetchEngines]);

  useEffect(() => {
    localStorage.setItem("categoryFilter", selectedCategory);
    localStorage.setItem("manufacturerFilter", selectedManufacturer);
    localStorage.setItem("engineApplicationFilter", selectedEngineApplication);
    localStorage.setItem("nbrCylindersFilter", selectedNbrCylinders);
    localStorage.setItem("fuelTypeFilter", selectedFuelType);
    localStorage.setItem("coolingSystemFilter", selectedCoolingSystem);
    localStorage.setItem("ignitionTypeFilter", selectedIgnitionType);
    localStorage.setItem("displacementMinFilter", selectedDisplacementMin);
    localStorage.setItem("displacementMaxFilter", selectedDisplacementMax);
    localStorage.setItem(
      "compressionRatioMinFilter",
      selectedCompressionRatioMin,
    );
    localStorage.setItem(
      "compressionRatioMaxFilter",
      selectedCompressionRatioMax,
    );
    localStorage.setItem("boreMinFilter", selectedBoreMin);
    localStorage.setItem("boreMaxFilter", selectedBoreMax);
    localStorage.setItem("strokeMinFilter", selectedStrokeMin);
    localStorage.setItem("strokeMaxFilter", selectedStrokeMax);
    localStorage.setItem("torqueMinFilter", selectedTorqueMin);
    localStorage.setItem("torqueMaxFilter", selectedTorqueMax);
    localStorage.setItem("powerOutputMinFilter", selectedPowerOutputMin);
    localStorage.setItem("powerOutputMaxFilter", selectedPowerOutputMax);
  }, [range]);

  const handleClear = () => {
    setSelectedCategory(""); // clears input
    localStorage.setItem("categoryFilter", ""); // ensures blank is saved
    setSelectedManufacturer(""); // clears input
    localStorage.setItem("manufacturerFilter", ""); // ensures blank is saved
    selectedEngineApplication && setSelectedEngineApplication("");
    localStorage.setItem("engineApplicationFilter", "");
    selectedNbrCylinders && setSelectedNbrCylinders("");
    localStorage.setItem("nbrCylindersFilter", "");
    selectedFuelType && setSelectedFuelType("");
    localStorage.setItem("fuelTypeFilter", "");
    selectedFuelSystem && setSelectedFuelSystem("");
    localStorage.setItem("fuelSystemFilter", "");
    selectedCoolingSystem && setSelectedCoolingSystem("");
    localStorage.setItem("coolingSystemFilter", "");
    selectedIgnitionType && setSelectedIgnitionType("");
    localStorage.setItem("ignitionTypeFilter", "");
    selectedDisplacementMin && setSelectedDisplacementMin("");
    localStorage.setItem("displacementMinFilter", "");
    selectedDisplacementMax && setSelectedDisplacementMax("");
    localStorage.setItem("displacementMaxFilter", "");
    selectedCompressionRatioMin && setSelectedCompressionRatioMin("");
    localStorage.setItem("compressionRatioMinFilter", "");
    selectedCompressionRatioMax && setSelectedCompressionRatioMax("");
    localStorage.setItem("compressionRatioMaxFilter", "");
    selectedBoreMin && setSelectedBoreMin("");
    localStorage.setItem("boreMinFilter", "");
    selectedBoreMax && setSelectedBoreMax("");
    localStorage.setItem("boreMaxFilter", "");
    selectedStrokeMin && setSelectedStrokeMin("");
    localStorage.setItem("strokeMinFilter", "");
    selectedStrokeMax && setSelectedStrokeMax("");
    localStorage.setItem("strokeMaxFilter", "");
    selectedTorqueMin && setSelectedTorqueMin("");
    localStorage.setItem("torqueMinFilter", "");
    selectedTorqueMax && setSelectedTorqueMax("");
    localStorage.setItem("torqueMaxFilter", "");
    selectedPowerOutputMin && setSelectedPowerOutputMin("0");
    localStorage.setItem("powerOutputMinFilter", "0");
    selectedPowerOutputMax && setSelectedPowerOutputMax("1000");
    localStorage.setItem("powerOutputMaxFilter", "1000");

    setRange([0, 1000]);
  };

  const handleSort = (key: keyof Engine) => {
    let direction: "ascending" | "descending" | null = "ascending";

    if (sortConfig.key === key) {
      if (sortConfig.direction === "ascending") {
        direction = "descending";
      } else if (sortConfig.direction === "descending") {
        direction = null;
      }
    }

    setSortConfig({ key, direction });
  };

  const getSortedEngines = () => {
    let filteredEngines = engines;

    if (!sortConfig.key || !sortConfig.direction) {
      return filteredEngines;
    }

    return [...filteredEngines].sort((a, b) => {
      const aValue = a[sortConfig.key!];
      const bValue = b[sortConfig.key!];

      // Handle different data types
      let aStr: string;
      let bStr: string;

      if (Array.isArray(aValue)) {
        aStr = aValue.join(", ");
        bStr = Array.isArray(bValue) ? bValue.join(", ") : "";
      } else if (typeof aValue === "boolean") {
        aStr = aValue ? "Yes" : "No";
        bStr = typeof bValue === "boolean" ? (bValue ? "Yes" : "No") : "";
      } else if (typeof aValue === "number") {
        aStr = aValue.toString();
        bStr = typeof bValue === "number" ? bValue.toString() : "";
      } else {
        aStr = aValue ? aValue.toString().toLowerCase() : "";
        bStr = bValue ? bValue.toString().toLowerCase() : "";
      }

      if (aStr < bStr) {
        return sortConfig.direction === "ascending" ? -1 : 1;
      }
      if (aStr > bStr) {
        return sortConfig.direction === "ascending" ? 1 : -1;
      }
      return 0;
    });
  };

  type Option = {
    name: string;
  };

  type SelectOption = {
    label: string;
    value: string;
  };

  type DropdownProps = {
    options: Option[];
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  };

  function Dropdown({ options, value, onChange }: DropdownProps) {
    return (
      <select value={value} onChange={onChange} style={{ width: "200px" }}>
        <option value="">All</option>
        {options.map((o) => (
          <option key={o.name} value={o.name}>
            {o.name}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="generalPage">
      <Header2 />
      <div className="pageContainer">
        <div className="espec-title-container">
          <div className="sectionContainer">
            <SecHeader title="ESPECTM Engine Comparison Tool" iSize={3} />
          </div>

          <div className="espec-container">
            <div className="espec-main-grid">
              {/* COLUMN A — FILTERS */}
              <div className="espec-filters-column">
                <div className="espec-card">
                  <div className="espec-section">
                    <label className="espec-filter-label">Power Output</label>
                    <div className="espec-filter-group-min-max">
                      <div className="espec-range-container">
                        <div className="espec-selected-range">
                          <div style={{ marginBottom: "10px" }}>
                            Selected range: {range[0]} hp - {range[1]} hp
                          </div>
                          <Slider.Root
                            value={range}
                            onValueChange={setRange}
                            min={0}
                            max={1000}
                            step={100}
                            style={{
                              position: "relative",
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              height: 40,
                            }}
                          >
                            <Slider.Track
                              style={{
                                backgroundColor: "#e5e7eb",
                                position: "relative",
                                flexGrow: 1,
                                height: 4,
                                borderRadius: 2,
                              }}
                            >
                              <Slider.Range
                                style={{
                                  position: "absolute",
                                  backgroundColor: "#0C929C",
                                  height: "100%",
                                  borderRadius: 9999,
                                }}
                              />
                            </Slider.Track>

                            <Slider.Thumb
                              style={{
                                display: "block",
                                width: 20,
                                height: 20,
                                backgroundColor: "#0C929C",
                                border: "2px solid #0C929C", // 👈 teal border
                                borderRadius: "50%",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                cursor: "pointer",
                              }}
                            />
                            <Slider.Thumb
                              style={{
                                display: "block",
                                width: 20,
                                height: 20,
                                backgroundColor: "#0C929C",
                                border: "2px solid #0C929C",
                                borderRadius: "50%",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                cursor: "pointer",
                              }}
                            />
                          </Slider.Root>

                          {/* Ticks */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: 10,
                            }}
                          >
                            {Array.from({ length: 11 }).map((_, i) => (
                              <span key={i} style={{ fontSize: 10 }}>
                                {i * 100}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="espec-section-nobackground">
                    <div className="espec-filter2-group">
                      <label className="espec-filter-label">
                        Ignition Type
                      </label>
                      <select
                        value={selectedIgnitionType}
                        onChange={(e) =>
                          setSelectedIgnitionType(e.target.value)
                        }
                      >
                        <option value="">All</option>
                        <option value="Compression">
                          Compression Ignition
                        </option>
                        <option value="Spark">Spark Ignition</option>
                      </select>
                      {/* <select
                   <option value="">-- Select --</option>
                  
                  onChange={(e) => setSelectedEngineApplication(e.target.value)}
                /> */}
                    </div>
                    <div className="espec-filter2-group">
                      <label className="espec-filter-label">
                        Application Type
                      </label>
                      <select
                        value={selectedEngineApplication}
                        onChange={(e) =>
                          setSelectedEngineApplication(e.target.value)
                        }
                      >
                        <option value="">All</option>
                        <option value="Land">Land</option>
                        <option value="Marine">Marine</option>
                        <option value="Air">Air</option>
                      </select>
                      {/* <select
                   <option value="">-- Select --</option>
                  
                  onChange={(e) => setSelectedEngineApplication(e.target.value)}
                /> */}
                    </div>
                  </div>

                  <div className="espec-section-nobackground">
                    <Button2
                      name="submit"
                      text="Clear All Filters"
                      type="button"
                      classname="submit-btn"
                      onClick={handleClear}
                    />
                  </div>
                </div>
              </div>
              {/* RIGHT SIDE (B + C) */}
              <div className="espec-columns-wrapper">
                {isLoading ? (
                  <div className="espec-loading-container">
                    <div className="espec-loading-spinner"></div>
                    <div className="espec-loading-text">Loading...</div>
                  </div>
                ) : (
                  <>
                    {noData && (
                      <div className="espec-no-data-container">
                        <div className="espec-no-data-message">
                          No results match your search criteria.
                        </div>
                      </div>
                    )}

                    <div className="espec-column">
                      {/* COLUMN B */}
                      <div className="espec-card">
                        <div className="espec-card-list">
                          {engines.map((engine, index) => {
                            const prevEngine = engines[index - 1];
                            const isSame =
                              prevEngine &&
                              prevEngine.compare_id === engine.compare_id;

                            return (
                              <div>
                                {prevEngine &&
                                  prevEngine.compare_id !==
                                    engine.compare_id && (
                                    <div className="compare-break">
                                      <hr></hr>
                                    </div>
                                  )}
                                <div
                                  key={index}
                                  className="espec-engine-card left-espec-table"
                                >
                                  <div className="compare-break">
                                    <div className="espec-engine-title">
                                      {engine.manufacturer} {engine.model}
                                    </div>

                                    <div className="espec-engine-grid">
                                      <div className="espec-item">
                                        <span className="label">
                                          Application
                                        </span>
                                        <span>{engine.engine_application}</span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Max Power Output (hp)
                                        </span>
                                        <span>{engine.power_output_hp}</span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Max Torque (lb-ft)
                                        </span>
                                        <span>{engine.torque_lbft}</span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Ignition Type
                                        </span>
                                        <span className="engine-data">
                                          {engine.ignition_type}
                                        </span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Displacement (L)
                                        </span>
                                        <span>{engine.displacement_l}</span>
                                      </div>
                                      <div className="espec-item">
                                        <span className="label">
                                          Dry Weight (lb)
                                        </span>
                                        <span>{engine.dry_weight_lb}</span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Cylinder Layout
                                        </span>
                                        <span>
                                          {engine.cylinder_configuration}
                                        </span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Compression Ratio
                                        </span>
                                        <span>{engine.compression_ratio}</span>
                                      </div>

                                      <div className="espec-item">
                                        <span className="label">
                                          Brake Thermal Efficiency
                                        </span>
                                        <span>
                                          {Math.round(
                                            engine.brake_thermal_efficiency,
                                          )}
                                          %
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* COLUMN C */}
                    <div className="espec-column">
                      <div className="espec-card">
                        <div className="espec-card-list">
                          {elfEngines.map((engine, index) => {
                            const prevElfEngine = elfEngines[index - 1];
                            const isElfSame =
                              prevElfEngine &&
                              prevElfEngine.compare_id === engine.compare_id;

                            return (
                              <div>
                                {prevElfEngine &&
                                  prevElfEngine.compare_id !==
                                    engine.compare_id && (
                                    <div className="compare-break">
                                      <hr></hr>
                                    </div>
                                  )}
                                <div
                                  key={index}
                                  className="espec-engine-card right-espec-table"
                                >
                                  <div className="espec-engine-title">
                                    {engine.manufacturer} {engine.model}{" "}
                                  </div>

                                  <div className="espec-engine-grid">
                                    <div className="espec-item">
                                      <span className="label">Application</span>
                                      <span>{engine.engine_application}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Max Power Output (hp)
                                      </span>
                                      <span>{engine.power_output_hp}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Max Torque (lb-ft)
                                      </span>
                                      <span>{engine.torque_lbft}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Ignition Type
                                      </span>
                                      <span>{engine.ignition_type}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Displacement (L)
                                      </span>
                                      <span>{engine.displacement_l}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Dry Weight (lb)
                                      </span>
                                      <span>{engine.dry_weight_lb}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Cylinder Layout
                                      </span>
                                      <span>
                                        {engine.cylinder_configuration}
                                      </span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Compression Ratio
                                      </span>
                                      <span>{engine.compression_ratio}</span>
                                    </div>

                                    <div className="espec-item">
                                      <span className="label">
                                        Brake Thermal Efficiency
                                      </span>
                                      <span>
                                        {Math.round(
                                          engine.brake_thermal_efficiency,
                                        )}
                                        %
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
              {/* END OF B-C Wrapper */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
